import { parseCookiesToUser } from '@quintoandar/wat-cookie';

const AGENT_PROFILE_CACHE_KEY = 'agentProfileData';
const AGENT_ROLES_CACHE_KEY = 'agentRoles';
const AGENT_PROFILE_UPDATED_TIME_CACHE_KEY = 'agentProfileUpdatedTime';
const CACHE_TTL = 12 * 60 * 60 * 1000;

export function isProfileCacheValid() {
  try {
    const agentProfileData = localStorage.getItem(AGENT_PROFILE_CACHE_KEY);
    if (!agentProfileData) return false;

    const agentData = JSON.parse(agentProfileData);
    const userCookieId = parseCookiesToUser()?.id;

    if (agentData?.id !== userCookieId) {
      return false;
    }

    const agentUpdatedTime = localStorage.getItem(
      AGENT_PROFILE_UPDATED_TIME_CACHE_KEY,
    );
    const isCacheValid =
      agentData &&
      agentUpdatedTime &&
      Date.now() - Number(agentUpdatedTime) < CACHE_TTL;
    return isCacheValid;
  } catch (error) {
    return false;
  }
}

export function clearProfileCache() {
  localStorage.removeItem(AGENT_PROFILE_CACHE_KEY);
  localStorage.removeItem(AGENT_PROFILE_UPDATED_TIME_CACHE_KEY);
  localStorage.removeItem(AGENT_ROLES_CACHE_KEY);
}

export function getProfileCache() {
  const agentProfileData = localStorage.getItem(AGENT_PROFILE_CACHE_KEY);
  if (!agentProfileData) return null;
  return JSON.parse(agentProfileData);
}

export function setProfileCache(payload) {
  localStorage.setItem(AGENT_ROLES_CACHE_KEY, payload.roles);
  localStorage.setItem(AGENT_PROFILE_CACHE_KEY, JSON.stringify(payload));
  localStorage.setItem(AGENT_PROFILE_UPDATED_TIME_CACHE_KEY, Date.now());
}
